import React from 'react';
import NoRecord from 'assets/img/no-data/noRecord-light.svg';
import NoRecordDark from 'assets/img/no-data/noRecord-dark.svg';

function Empty() {
  return (
    <>
      <img src={NoRecord} className="d-dark-none" height={200} />
      <img src={NoRecordDark} className="d-light-none" height={200} />
    </>
  );
}

export default Empty;
